module.exports = __webpack_public_path__ + "static/media/cornernotConnected.15003ea6.svg";